<h2 mat-dialog-title class="dialog-title">
  {{ data.mode === 'create' ? 'Neue Abweichung' : 'Abweichung bearbeiten' }}
</h2>

<mat-dialog-content class="mat-typography dialog-content">
  <!-- Loading indicator -->
  <div *ngIf="loading" class="loading-container">
    <p>Lade Daten...</p>
  </div>
  
  <form [formGroup]="abweichungForm" *ngIf="!loading">
    <!-- Titel -->
    <div class="form-group">
      <label class="form-label" for="caption">Titel *</label>
      <input
        type="text"
        class="form-control"
        id="caption"
        formControlName="caption"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Titel der Abweichung" />
    </div>

    <!-- Beschreibung -->
    <div class="form-group">
      <label class="form-label" for="description">Beschreibung *</label>
      <textarea
        id="description"
        formControlName="description"
        rows="4"
        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Detaillierte Beschreibung der Abweichung"></textarea>
    </div>

    <!-- Sortierung -->
    <div class="form-group">
      <label class="form-label" for="sortierung">Sortierung *</label>
      <input
        type="number"
        class="form-control"
        id="sortierung"
        formControlName="sortierung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Sortierung" />
    </div>

    <!-- Status -->
    <div class="form-group">
      <label class="form-label" for="status">Status *</label>
      <select
        id="status"
        formControlName="status"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Bitte wählen...</option>
        <option value="active">Aktiv</option>
        <option value="inactive">Inaktiv</option>
      </select>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button mat-button (click)="onSubmit()" cdkFocusInitial>Speichern</button>
</mat-dialog-actions>
